var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeartOutline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6832 17.9087L10.6813 17.9104C10.4972 18.0756 10.2567 18.1675 10.0065 18.1666C9.75642 18.1657 9.51659 18.0721 9.33372 17.9055L9.3326 17.9045L9.22345 17.8054L9.22346 17.8054L9.21914 17.8015C6.5736 15.4272 4.47264 13.5363 3.03616 11.7699C1.6141 10.0213 0.949859 8.52051 1.00296 6.93807C1.02771 6.25376 1.21261 5.58433 1.5433 4.98291C1.87271 4.38382 2.33786 3.86847 2.90249 3.47777C3.88433 2.83063 5.07215 2.56431 6.23978 2.73068C7.41044 2.89747 8.4769 3.48721 9.23591 4.38542C9.42486 4.60903 9.70232 4.73861 9.99507 4.73997C10.2878 4.74133 10.5665 4.61434 10.7575 4.3925C12.237 2.6743 14.9371 2.01056 17.0919 3.47429C17.6588 3.8654 18.1258 4.38204 18.4561 4.98291C18.787 5.58465 18.9719 6.25447 18.9965 6.93916L18.9965 6.93965C19.0541 8.52063 18.3911 10.0206 16.9671 11.7726C15.5296 13.5411 13.4276 15.4358 10.7835 17.8192L10.7833 17.8194L10.7798 17.8225L10.6832 17.9087Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartOutline);
export default __webpack_public_path__ + "static/media/heart-outline.1e780baafaab1d35751051468e31ba4f.svg";
export { ForwardRef as ReactComponent };